import React, { useCallback, useContext, useState } from "react";

import { GlobalContext } from "../../globals/globalContext.jsx";
import { Authenticate } from "../login/LoginController.jsx";
import Template from "./Settings.jsx";

function SettingsController(props) {
  const [activeTabIndex, setActiveTabIndex] = useState(props.activeTabIndex);
  const [fromFooter, setFromFooter] = useState(props.fromFooter);

  const { subscription, setSubscription, fetchDelivery } =
    useContext(GlobalContext);
  const { setDeliveryAddress } = useContext(GlobalContext);

  const onTabChange = useCallback((i) => {
    setActiveTabIndex(i);
  }, []);

  const onBackClick = useCallback(() => {
    if (fromFooter === true) {
      setActiveTabIndex(undefined);
      setFromFooter(undefined);
      onCloseClick();
    } else {
      closeTab();
    }
  }, [fromFooter]);

  const onLogoutClick = useCallback(
    (e) => {
      e.preventDefault();
      const { logout, onClose } = props;
      logout().then(() => {
        onClose && onClose();
        window.location.href = "/";
      });
    },
    [props],
  );

  const onTabSuccess = useCallback(() => {
    closeTab();
  }, []);

  const onProfileSuccess = useCallback(
    async (customer, newDeliveryAddress = undefined) => {
      const { onChange } = props;
      closeTab();
      setSubscription((prevSubscription) => ({
        ...prevSubscription,
        customer: customer,
      }));
      onChange && onChange(subscription);
      await fetchDelivery();
      newDeliveryAddress && setDeliveryAddress(newDeliveryAddress);
    },
    [props, fetchDelivery],
  );

  const closeTab = useCallback(() => {
    setActiveTabIndex(undefined);
  }, []);

  const onCloseClick = useCallback(() => {
    const { onClose } = props;
    onClose && onClose();
  }, [props]);

  const handlers = {
    onTabChange,
    onBackClick,
    onLogoutClick,
    onCloseClick,
    onTabSuccess,
    onProfileSuccess,
  };

  return (
    <Template
      {...props}
      activeTabIndex={activeTabIndex}
      fromFooter={fromFooter}
      {...handlers}
    />
  );
}

export default Authenticate(SettingsController);
